import React from "react";

// Nested Hauora Rings Component
// Center: Wairua (Blue) -> Hinengaro (Yellow) -> Tinana (Red) -> Whānau (Green - Outer)
const NestedHauoraRings = ({ 
  wairuaCompleted = false,
  hinengaroCompleted = false,
  tinanaCompleted = false,
  whanauCompleted = false,
  size = 200,
  onClick
}) => {
  // Muted, refined colors
  const colors = {
    wairua: { active: "#5B8BA0", inactive: "#E8EFF2" },      // Muted Blue
    hinengaro: { active: "#D4A84B", inactive: "#F5EFE0" },   // Muted Yellow/Gold
    tinana: { active: "#B85C4C", inactive: "#F2E8E6" },      // Muted Red/Clay
    whanau: { active: "#3D6B5A", inactive: "#E5EBE8" }       // Muted Green
  };

  const strokeWidth = 10;
  const gap = 4;
  const centerX = size / 2;
  const centerY = size / 2;

  // Calculate radii for nested rings (outside to inside)
  const rings = [
    { key: "whanau", radius: (size / 2) - strokeWidth / 2, completed: whanauCompleted },
    { key: "tinana", radius: (size / 2) - strokeWidth - gap - strokeWidth / 2, completed: tinanaCompleted },
    { key: "hinengaro", radius: (size / 2) - (strokeWidth + gap) * 2 - strokeWidth / 2, completed: hinengaroCompleted },
    { key: "wairua", radius: (size / 2) - (strokeWidth + gap) * 3 - strokeWidth / 2, completed: wairuaCompleted }
  ];

  return (
    <div 
      className="relative cursor-pointer transition-transform hover:scale-105"
      onClick={onClick}
      data-testid="nested-hauora-rings"
    >
      <svg width={size} height={size} className="transform -rotate-90">
        {/* Render rings from outside to inside */}
        {rings.map((ring) => {
          const circumference = 2 * Math.PI * ring.radius;
          const color = colors[ring.key];
          
          return (
            <g key={ring.key}>
              {/* Background track */}
              <circle
                cx={centerX}
                cy={centerY}
                r={ring.radius}
                fill="none"
                stroke={color.inactive}
                strokeWidth={strokeWidth}
              />
              {/* Filled ring when completed */}
              <circle
                cx={centerX}
                cy={centerY}
                r={ring.radius}
                fill="none"
                stroke={ring.completed ? color.active : "transparent"}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={circumference}
                strokeDashoffset={ring.completed ? 0 : circumference}
                style={{
                  transition: "stroke-dashoffset 0.8s ease-out, stroke 0.3s ease"
                }}
              />
            </g>
          );
        })}
      </svg>
      
      {/* Center indicator */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div 
          className={`w-8 h-8 rounded-full transition-all duration-500 ${
            wairuaCompleted && hinengaroCompleted && tinanaCompleted && whanauCompleted
              ? "bg-[#0B3D2E] scale-100"
              : "bg-[#E3EBE5] scale-75"
          }`}
        >
          {wairuaCompleted && hinengaroCompleted && tinanaCompleted && whanauCompleted && (
            <svg className="w-full h-full p-1.5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
              <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
      </div>
    </div>
  );
};

export default NestedHauoraRings;
